(function ($) {
  const RESPONSIVE_VOICE_SCRIPT_ID = 'rvid';
  const RESPONSIVE_VOICE_API_KEY = 'UQ8wlrv1';
  const RESPONSIVE_VOICE_API_ENDPOINT = 'https://code.responsivevoice.org/';
  const RESPONSIVE_VOICE_URL = `${RESPONSIVE_VOICE_API_ENDPOINT}responsivevoice.js?key=${RESPONSIVE_VOICE_API_KEY}`;
  const AUDIO_READOUT_VOICE_RATE = 1.04;
  
  function enableReadout() {
    const uebElement = $('.ueb');
    if (!uebElement.length) return;

    let currentState;

    function setState(newState) {
      currentState = newState;
    }

    function showButton(button) {
      button.classList.remove(hideClass);
    }

    function hideButton(button) {
      button.classList.add(hideClass);
    }

    const hideClass = 'hide';
    const playButtonId = '#ueb-play-container';
    const playButtonContainerId = '#ueb-play-container';
    const playButtonContainer = $(playButtonContainerId)[0];
    const pauseButtonId = '#ueb-pause-container';
    const pauseButtonContainerId = '#ueb-pause-container';
    const pauseButtonContainer = $(pauseButtonContainerId)[0];

    if (!responsiveVoice.voiceSupport()) {
      hideButton(playButtonContainer);
      hideButton(pauseButtonContainer);
      return;
    }

    responsiveVoice.enableWindowClickHook();
    responsiveVoice.enableEstimationTimeout = false;

    document.addEventListener('visibilitychange', () => {
      // in case we lose focus of the page we cancel the readout
      cancelReadout();

      hideButton(pauseButtonContainer);
      showButton(playButtonContainer);
    });

    const audioReadoutContentArray = getReadoutContent();
    let audioReadoutContentIndex = 0;

    const STATES = {
      READY: 'READY',
      PLAYING: 'PLAYING',
      PAUSED: 'PAUSED'
    };

    /**
     * For more option on voices check the documentation on:
     * https://responsivevoice.org/text-to-speech-languages/
     */
    const audioReadoutVoice = 'US English Female';

    function getReadoutContent() {
      const content = [...document.querySelectorAll('[data-readout="true"]')]
        .map(contentPart => [].slice.call(contentPart.children))
        .flat(Infinity);

      return content;
    }

    function cancelReadout() {
      responsiveVoice.cancel();
      setState(STATES.READY);
    }

    function voiceStartCallback() {
      if (currentState === STATES.PLAYING) return;
      setState(STATES.PAUSED);
    }

    function onErrorCallback() {
      setState(STATES.READY);
    }

    function voiceEndCallback() {
      if (audioReadoutContentIndex === audioReadoutContentArray.length - 1) {
        setState(STATES.READY);
        audioReadoutContentIndex = 0;
        return;
      }
      audioReadoutContentIndex++;
      startAudioReadout();
    }

    function startAudioReadout() {
      if (audioReadoutContentArray && audioReadoutContentArray.length) {
        let audioReadoutElement = audioReadoutContentArray[audioReadoutContentIndex];

        /**
         * – onstart: Speech started playing.
         * – onend: Speech ended playing.
         * – onerror: There was some error.
         * – onpause*: Speech was paused.
         * – onresume*: Speech started playing after being paused.
         */
        responsiveVoice.speak(audioReadoutElement.textContent, audioReadoutVoice, {
          rate: AUDIO_READOUT_VOICE_RATE,
          onstart: voiceStartCallback,
          onend: voiceEndCallback,
          onerror: onErrorCallback
        });
      }
    }

    function handlePlay(e) {
      e.preventDefault();
      if (currentState === STATES.READY || currentState === STATES.PAUSED) {
        hideButton(playButtonContainer);
        showButton(pauseButtonContainer);
        setState(STATES.PLAYING);
        startAudioReadout();
      }
    }

    function handlePause(e) {
      e.preventDefault();

      hideButton(pauseButtonContainer);
      showButton(playButtonContainer);
      setState(STATES.PAUSED);
      cancelReadout();
    }

    function elementIsInViewPort(element) {
      const rect = element.getBoundingClientRect();

      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    }

    setState(STATES.READY);
    $(document).on('click', playButtonId, handlePlay);
    $(document).on('click', pauseButtonId, handlePause);
  }

  const loadDynamicScript = callback => {
    const existingScript = document.getElementById(RESPONSIVE_VOICE_SCRIPT_ID);

    if (!existingScript) {
      const script = document.createElement('script');
      script.src = RESPONSIVE_VOICE_URL;
      script.id = RESPONSIVE_VOICE_SCRIPT_ID;
      document.body.appendChild(script);

      script.onload = () => {
        if (callback) callback();
      };
    }

    if (existingScript && callback) callback();
  };

  // load library dynamically and enable the readout once it is ready
  $(document).ready(() => loadDynamicScript(enableReadout));
})(jQuery);
